export default class inspectionApplications {
  constructor(
    id,
    inspectorCoordinates,
    createdAt,
    currentStatus,
    endDate,
    establishmentCode,
    establishmentDirection,
    establishmentName,
    establishmentZone,
    inspectionRequestImages,
    inspectionEvents,
    inspectionExportZone,
    inspectionType,
    inspectorInternalCode,
    inspectorFullName,
    reasonForRejection,
    startDate,
    upCode,
    upPolygonCoordinates,
    upPolygonSize,
    upSquareDistance,
    inspectionStartDate,
    inspectionEndDate
  ) {
    this.id = id;
    this.inspectorCoordinates = inspectorCoordinates;
    this.createdAt = createdAt;
    this.currentStatus = currentStatus;
    this.endDate = endDate;
    this.establishmentCode = establishmentCode;
    this.establishmentDirection = establishmentDirection;
    this.establishmentName = establishmentName;
    this.establishmentZone = establishmentZone;
    this.inspectionRequestImages = inspectionRequestImages;
    this.inspectionEvents = inspectionEvents;
    this.inspectionExportZone = inspectionExportZone;
    this.inspectionType = inspectionType;
    this.inspectorFullName = inspectorFullName;
    this.reasonForRejection = reasonForRejection;
    this.startDate = startDate;
    this.upCode = upCode;
    this.upPolygonCoordinates = upPolygonCoordinates;
    this.upPolygonSize = upPolygonSize;
    this.upSquareDistance = upSquareDistance;
    this.inspectionEndDate = inspectionEndDate;
    this.inspectionStartDate = inspectionStartDate;
    this.inspectorInternalCode = inspectorInternalCode;
  }

  static fromJSON(properties) {
    return new inspectionApplications(
      properties?.id ?? "",
      properties?.inspectorCoordinates ?? [],
      properties?.createdAt ?? "",
      properties?.currentStatus ?? "",
      properties?.endDate ?? "",
      properties?.establishmentCode ?? "",
      properties?.establishmentDirection ?? "",
      properties?.establishmentName ?? "",
      properties?.establishmentZone ?? "",
      properties?.inspectionRequestImages ?? [],
      properties?.inspectionEvents ?? "",
      properties?.inspectionExportZone ?? "",
      properties?.inspectionType ?? "",
      properties?.inspectorInternalCode ?? "",
      properties?.inspector?.fullName ?? "",
      properties?.reasonForRejection ?? "",
      properties?.startDate ?? "",
      properties?.upCode ?? "",
      properties?.upPolygonCoordinates ?? [],
      properties?.upPolygonSize ?? "",
      properties?.upSquareDistance ?? "",
      properties?.inspectionStartDate ?? "",
      properties?.inspectionEndDate ?? "",
    );
  }
}
